import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { SHUI_MODAL_CONFIG, ShuiModalConfig, ShuiModalRef, ShButtonComponent } from '@gbr-monorepo/gbr-shui';
import { TranslateModule } from '@ngx-translate/core';

export interface DeleteUserDialogData {
    gid: string;
    firstName: string;
    lastName: string;
}

@Component({
    selector: 'app-delete-user-dialog',
    templateUrl: './delete-user.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ShButtonComponent, TranslateModule]
})
export class DeleteUserComponent {
    public readonly config: ShuiModalConfig<DeleteUserDialogData> =
        inject<ShuiModalConfig<DeleteUserDialogData>>(SHUI_MODAL_CONFIG);
    private readonly modalRef = inject<ShuiModalRef<string>>(ShuiModalRef);

    protected get data(): DeleteUserDialogData | undefined {
        return this.config?.data;
    }

    public deleteUser(): void {
        this.modalRef.close('delete');
    }

    public cancel(): void {
        this.modalRef.close();
    }
}
